<div class="footer__container">
  <img src="/icons/footer/logo-footer.svg" />

  <ul class="footer__links">
    <li><a routerLink="tarifs">Tarifs</a></li>
    <li>
      <a routerLink="/rendez-vous">Prendre rendez-vous</a>
    </li>
    <li>
      <a routerLink="/conditions-generales-utilisation">CGU </a> /
      <a routerLink="/conditions-generales-ventes">CGV </a>
    </li>
    <li>
      <a routerLink="/politique-de-confidentialite">Politique de confidentialité</a>
    </li>
  </ul>

  <ul class="footer__links">
    <li><a routerLink="/offres-emplois">Offres d’emplois</a></li>
    <li>
      <a routerLink="/offres-stages">Offres de stage</a>
    </li>
    <li>
      <a routerLink="/mentions-legales">Mentions légales</a>
    </li>
    <li>
      <a href="https://www.linkedin.com/company/cescog">Réseaux sociaux</a>
    </li>
  </ul>
</div>
